import Marionette from "backbone.marionette";
import Cleave from "cleave.js";
import $ from "jquery";

import { validateEmail, validatePhone } from "lib/util";

import config from "../config";
import template from "../templates/components/authPass.jst";

const SetPasswordView = Marionette.View.extend({
    template,
    ui: {
        password: "#password",
        checkPassword: "#check-password",
        phone: "#phone",
        email: "#email",
        passwordBtn: "#btn-password",
        helpChars: "#help-chars",
        form: ".form-group",
        error: ".help-block",
    },
    events: {
        "click @ui.passwordBtn": "onSubmit",
    },
    onSubmit(event) {
        event.preventDefault();

        this.submit();
    },
    validate() {
        if (!$("#password").length) return false;

        this.ui.helpChars.removeClass("help-block");
        this.ui.error.text("");

        const password = this.ui.password.val();
        if (!password || password.length < 6) {
            this.ui.error.text("Password must be at least 6 characters");
            return false;
        }

        if (this.ui.checkPassword.length && this.ui.checkPassword.val() !== password) {
            this.ui.error.text("Your passwords don't match");
            return false;
        }

        if (this.ui.email.length && !validateEmail(this.ui.email.val())) {
            this.ui.error.text("Please enter a valid email");
            return false;
        }

        if (this.ui.phone.length && !validatePhone(this.ui.phone.val())) {
            this.ui.error.text("Please enter a valid phone number");
            return false;
        }

        return true;
    },
    getData() {
        const password = this.ui.password.val();
        const data = {
            password,
            csrf_token: window.csrfToken,
        };

        if (this.ui.phone.val()) {
            data.phone = this.ui.phone.val();
        }

        if (this.ui.email.val()) {
            data.email = this.ui.email.val();
        }

        return data;
    },
    submit() {
        // TURN ON LOADER H?ERE

        if (!this.validate()) {
            return false;
        }

        const data = this.getData();

        const url = this.options.isPortal ? "/api/v1/auth/" : "/api/hire/v1/auth/";

        return $.ajax({
            type: "PATCH",
            url,
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        })
            .done(this.onSuccess.bind(this))
            .fail(this.onError.bind(this));
    },
    onSuccess() {
        $.modal.close();
        this.ui.password.remove();
        this.trigger("auth:success");
    },
    onError(data) {
        if (data.responseJSON && "error" in data.responseJSON) {
            const msg = data.responseJSON.error;
            this.showError(msg, msg.toLowerCase());
        }
    },
    showError(msg, msgLower) {
        this.ui.form.addClass("has-error");

        if (msgLower.indexOf("hone") > -1) {
            // ya, I did
            this.ui.phone.siblings(".help-block").text(msg);
        } else if (msgLower.indexOf("email") > -1) {
            this.ui.email.siblings(".help-block").text(msg);
        } else {
            this.ui.error.last().text(msg);
        }
    },
    serializeData() {
        return {
            email: this.options.email,
            phone: this.options.phone,
            reset: this.options.reset,
            isPortal: this.options.isPortal,
        };
    },
    onRender() {
        this.bindUIElements();

        if (this.options.phone) {
            this.ui.phone.val(this.options.phone);
        }

        if (this.options.email) {
            this.ui.email.val(this.options.email);
        }

        if (this.ui.phone.length) {
            /* eslint-disable no-new */
            new Cleave(this.ui.phone, config.cleave.PHONE_CONFIG);
            /* eslint-enable */
        }
    },
});

export default SetPasswordView;
